import { render, staticRenderFns } from "./file.vue?vue&type=template&id=f16d939a"
import script from "./file.vue?vue&type=script&lang=js"
export * from "./file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f16d939a')) {
      api.createRecord('f16d939a', component.options)
    } else {
      api.reload('f16d939a', component.options)
    }
    module.hot.accept("./file.vue?vue&type=template&id=f16d939a", function () {
      api.rerender('f16d939a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/form/file.vue"
export default component.exports